export const COMPANYPROFILE = 'COMPANYPROFILE';

export const companyprofile = (stats: any) => ({
  type:COMPANYPROFILE,
  payload: stats
});